export const siteMeta = {
  brand: "塌房观察室",
  slogan: "让吃瓜不止于看热闹",
  englishLabel: "DISILLUSION LAB",
};

export const heroStat = [
  { num: "128", label: "事件档案盘点" },
  { num: "9", label: "主流人设类型" },
  { num: "36", label: "深度拆解报告" },
  { num: "24w", label: "理性吃瓜人群" },
];

export const tickerItems = [
  "清纯甜妹人设疑似旧照流出",
  "学霸才女人设被指学历存疑",
  "「好男人」老公人设再度反转",
  "独立大女主言论遭考古打脸",
  "佛系人设被曝线下激烈行为",
  "全能偶像翻车事件登上热榜",
];

export interface EventItem {
  tag: string;
  title: string;
  desc: string;
  heat: string;
  time: string;
  img: string;
}

export const events: EventItem[] = [
  {
    tag: "清纯甜妹",
    title: "「初恋脸」翻车：清纯人设崩塌的三种典型路径",
    desc: "从旧照考古到素人爆料，当『纯欲感』被逐帧拆解，滤镜碎掉只在一夜之间。",
    heat: "98.6w",
    time: "2小时前",
    img: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20fragile%20glossy%20pink%20porcelain%20mask%20with%20a%20deep%20hairline%20crack%20running%20through%20the%20face%2C%20warm%20amber%20studio%20light%2C%20dark%20charcoal%20background%2C%20cinematic%20high%20contrast%2C%20moody%20stylized%20concept%20art%2C%20not%20a%20real%20person&width=640&height=800&seq=ev-sweet-x1&orientation=portrait",
  },
  {
    tag: "学霸才女",
    title: "学历与谈吐双重打脸，才女人设为何最怕考古",
    desc: "谈吐会被翻旧账，学历会被核验。人设越完美，破绽越容易被放大审视。",
    heat: "87.2w",
    time: "5小时前",
    img: "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20golden%20graduation%20cap%20and%20stacked%20hardcover%20books%20cracked%20and%20fractured%2C%20amber%20side%20light%20on%20dark%20background%2C%20cinematic%20high%20contrast%2C%20moody%20stylized%20concept%20art%2C%20warm%20tones&width=640&height=800&seq=ev-scholar-x2&orientation=portrait",
  },
  {
    tag: "完美伴侣",
    title: "「好男人」人设崩塌：宠妻叙事为何总被反噬",
    desc: "越甜蜜的剧本越藏风险，当宠妻通稿遇上私人录音，崩塌的速度超乎想象。",
    heat: "76.9w",
    time: "8小时前",
    img: "https://readdy.ai/api/search-image?query=editorial%20still%20of%20two%20ceramic%20rings%20and%20a%20broken%20heart%20shaped%20crack%20in%20a%20dark%20stone%20surface%2C%20warm%20low%20key%20lighting%2C%20cinematic%20moody%20stylized%20concept%20art%2C%20dramatic%20shadow%2C%20warm%20brown%20and%20amber%20tones&width=640&height=800&seq=ev-lover-x3&orientation=portrait",
  },
  {
    tag: "独立大女主",
    title: "人设自由的核心矛盾：营业人设与真实自我的缝隙",
    desc: "当刻意塑造的独立宣言被逐条对照真实言行，翻车往往源于话术大于事实。",
    heat: "64.3w",
    time: "12小时前",
    img: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20marble%20female%20bust%20statue%20with%20a%20single%20vertical%20crack%20glowing%20warm%20light%2C%20dark%20velvet%20background%2C%20cinematic%20high%20contrast%20rim%20light%2C%20moody%20stylized%20concept%20art%2C%20warm%20coral%20accent&width=640&height=800&seq=ev-power-x4&orientation=portrait",
  },
  {
    tag: "知性主持人",
    title: "知性优雅背后：谈吐翻车与知识储备的真相",
    desc: "知性是一层壳，壳里有没有真东西，公开场合一开口便见分晓。",
    heat: "52.8w",
    time: "1天前",
    img: "https://readdy.ai/api/search-image?query=editorial%20still%20of%20an%20antique%20microphone%20with%20a%20shattered%20glass%20lens%20in%20front%2C%20warm%20amber%20studio%20light%2C%20dark%20background%2C%20cinematic%20moody%20stylized%20concept%20art%2C%20high%20contrast&width=640&height=800&seq=ev-host-x5&orientation=portrait",
  },
  {
    tag: "佛系隐退",
    title: "人淡如菊却营业凶猛？佛系人设的反差现场",
    desc: "镜头前岁月静好，镜头后寸步不让。人设与行为之间的裂缝最容易露馅。",
    heat: "45.1w",
    time: "1天前",
    img: "https://readdy.ai/api/search-image?query=editorial%20still%20of%20a%20single%20white%20orchid%20flower%20emerging%20from%20a%20cracked%20dark%20ceramic%20vase%2C%20warm%20low%20key%20lighting%2C%20cinematic%20moody%20stylized%20concept%20art%2C%20dark%20background%2C%20delicate%20high%20contrast&width=640&height=800&seq=ev-buddha-x6&orientation=portrait",
  },
];

export interface Archetype {
  name: string;
  en: string;
  icon: string;
  note: string;
  collapse: string;
  img: string;
}

export const archetypes: Archetype[] = [
  {
    name: "清纯甜妹型",
    en: "Sweet Girl",
    icon: "ri-flower-line",
    note: "靠『初恋脸』与纯欲氛围吸粉，主打干净无害的邻家感。",
    collapse: "最怕旧照考古与素人实锤，清纯一旦被证实『装』，人设即塌。",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20a%20cracked%20pink%20glossy%20porcelain%20mask%20on%20a%20dark%20stone%20pedestal%2C%20warm%20amber%20light%2C%20moody%20stylized%20concept%20art&width=600&height=460&seq=arc-sweet-x1&orientation=landscape",
  },
  {
    name: "学霸才女型",
    en: "Genius Girl",
    icon: "ri-graduation-cap-line",
    note: "以高学历、高智商、高谈吐为卖点，树立精英女性形象。",
    collapse: "学术履历与发言谈吐一旦被放大核验，破绽便无处遁形。",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20a%20cracked%20marble%20column%20topped%20with%20an%20open%20book%2C%20warm%20side%20light%2C%20dark%20moody%20background%2C%20stylized%20concept%20art&width=600&height=460&seq=arc-genius-x2&orientation=landscape",
  },
  {
    name: "完美伴侣型",
    en: "Perfect Partner",
    icon: "ri-heart-3-line",
    note: "凭借宠妻、顾家、深情的好男人叙事赢得大众信任。",
    collapse: "甜蜜剧本与真实关系一旦对不上号，深情反而成了最大讽刺。",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20a%20cracked%20wedding%20ring%20lying%20on%20dark%20textured%20stone%2C%20warm%20low%20key%20amber%20light%2C%20moody%20stylized%20concept%20art&width=600&height=460&seq=arc-lover-x3&orientation=landscape",
  },
  {
    name: "独立大女主题",
    en: "Big Sister",
    icon: "ri-sparkling-2-line",
    note: "以清醒、独立、强韧的『大女主』叙事构建职业女性想象。",
    collapse: "独立宣言与依赖现实一旦背离，粉丝的『代入感』随之崩塌。",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20a%20cracked%20marble%20female%20bust%20with%20warm%20coral%20light%20seeping%20from%20fractures%2C%20dark%20background%2C%20moody%20stylized%20concept%20art&width=600&height=460&seq=arc-sister-x4&orientation=landscape",
  },
];

export interface FlowStep {
  step: string;
  en: string;
  icon: string;
  title: string;
  desc: string;
}

export const flowSteps: FlowStep[] = [
  {
    step: "01",
    en: "CAST",
    icon: "ri-magic-line",
    title: "人设铸造期",
    desc: "团队依据市场定位挑选『角色剧本』，通过包装、通稿与综艺剪辑不断强化人设标签。",
  },
  {
    step: "02",
    en: "RENT",
    icon: "ri-vip-crown-line",
    title: "滤镜红利期",
    desc: "完美人设带来信任与高溢价，代言、片约、流量随之蜂拥而至，光环持续放大。",
  },
  {
    step: "03",
    en: "CRACK",
    icon: "ri-zoom-in-line",
    title: "裂缝初现",
    desc: "旧料被考古、素人现身爆料、言行前后对照，第一道裂缝在暗处悄悄蔓延。",
  },
  {
    step: "04",
    en: "STORM",
    icon: "ri-fire-line",
    title: "舆论发酵",
    desc: "事件冲上热搜，粉丝站队、路人围观、多方反转讨论，热度把细节越扒越深。",
  },
  {
    step: "05",
    en: "FALL",
    icon: "ri-settings-3-line",
    title: "人设崩塌",
    desc: "实锤落地，代言解约、滤镜尽碎，公众眼中的『完美』被一次性归零。",
  },
  {
    step: "06",
    en: "AFTERMATH",
    icon: "ri-eye-off-line",
    title: "幻灭余波",
    desc: "粉丝脱粉、行业反思、媒体复盘，一场滤镜集体的幻灭正式进入尾声。",
  },
];

export interface DeepArticle {
  tag: string;
  title: string;
  summary: string;
  minutes: string;
  reads: string;
  img: string;
}

export const deepArticles: DeepArticle[] = [
  {
    tag: "行业拆解",
    title: "为什么越『完美』的人设，越容易塌得彻底？",
    summary: "完美意味着零容错。当公众以『神』的标准审视一个普通人，任何瑕疵都会被无限放大。本文从人设经济学角度，拆解完美形象为何是一把双刃剑。",
    minutes: "12",
    reads: "36.4w",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20shot%20of%20a%20grand%20pedestal%20under%20a%20single%20spotlight%20with%20a%20crack%20running%20up%20the%20center%2C%20warm%20amber%20and%20dark%20tones%2C%20moody%20stylized%20concept%20art%2C%20high%20contrast&width=900&height=600&seq=deep-perfect-x1&orientation=landscape",
  },
  {
    tag: "心理观察",
    title: "塌房之后，粉丝到底在『塌』什么？",
    summary: "粉丝投入的从来不只是作品，更是一整套关于理想自我的投射。当偶像人设崩塌，崩塌的其实是粉丝心中那份『理想生活的样板』。",
    minutes: "9",
    reads: "21.8w",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20many%20small%20glowing%20candles%20around%20a%20cracked%20mirror%20reflecting%20warm%20light%2C%20dark%20moody%20background%2C%20stylized%20concept%20art%2C%20emotional%20high%20contrast&width=900&height=600&seq=deep-fan-x2&orientation=landscape",
  },
  {
    tag: "媒介批评",
    title: "滤镜经济的黄昏：我们如何被完美主义集体绑架",
    summary: "从精修海报到综艺人设，媒介把『完美』包装成一种可交易的商品。本文审视滤镜工业如何塑造审美焦虑，也塑造了一次次的幻灭现场。",
    minutes: "14",
    reads: "29.1w",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20a%20lens%20filter%20layered%20over%20a%20hazy%20shattered%20portrait%20outline%2C%20warm%20coral%20and%20amber%20light%2C%20dark%20background%2C%20moody%20stylized%20concept%20art&width=900&height=600&seq=deep-media-x3&orientation=landscape",
  },
  {
    tag: "行业观察",
    title: "翻车公关手册：形象坍塌后，还有几种『抢救』姿势？",
    summary: "冷处理、共情道歉、转移视线还是彻底隐身？人设崩塌之后的公关路径，往往决定了艺人能否二次出发。一次读完行业内幕。",
    minutes: "11",
    reads: "17.6w",
    img: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20a%20stack%20of%20scattered%20paper%20documents%20with%20a%20stamp%20in%20low%20warm%20light%2C%20dark%20desk%20background%2C%20moody%20stylized%20concept%20art%2C%20high%20contrast&width=900&height=600&seq=deep-pr-x4&orientation=landscape",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "到底什么是『女神塌房』？",
    a: "「女神塌房」指粉丝和大众心中塑造得近乎完美的女艺人或公众人物，因旧料、爆料或言行翻车导致完美形象在一夜之间崩塌的现象。『塌房』源自饭圈语境，形容偶像人设像房子一样轰然倒塌。",
  },
  {
    q: "『人设崩塌』和普通的舆论翻车有什么区别？",
    a: "普通翻车往往指向单次事件，而人设崩塌是针对一个人长期经营的『完美角色』进行整体证伪。它意味着此前的所有美好叙事被一次性推翻，信任基础归零，伤害也更深。",
  },
  {
    q: "为什么越完美的形象越容易塌？",
    a: "因为『完美』设置了零容错的高标准。公众一旦把艺人当神来看待，就会用神的尺子去量其每一个言行。人设越极端、越不真实，被证伪时的落差就越大，崩塌就越彻底。",
  },
  {
    q: "粉丝在塌房时到底失去了什么？",
    a: "很多粉丝投入的不只是时间与金钱，更是一份关于理想自我和理想生活的投射。当偶像人设崩塌，破碎的是粉丝所依赖的情感寄托与认同感，所以反应常常格外剧烈。",
  },
  {
    q: "作为吃瓜群众，该如何理性看待塌房事件？",
    a: "建议只看实锤、不轻易站队，把追星当成娱乐而不是信仰。多关注作品本身而非完美人设，少一点『神化』，多一点平常心，就能减少被一次次滤镜幻灭击中。",
  },
  {
    q: "塌房之后，艺人还能重新被公众接受吗？",
    a: "有可能，但需要时间与真诚。能否重建信任，取决于是否坦诚面对错误、用真实的作品与人格慢慢填补裂痕。标签化的人设或公关式表演，往往只会再次翻车。",
  },
];

export interface Voice {
  quote: string;
  name: string;
  role: string;
}

export const voices: Voice[] = [
  {
    quote: "这个专题最大的价值，是教会我用『看人设』的眼光去看所有公众人物，包括我自己追的那位。理性很多。",
    name: "林小姐",
    role: "追星五年的站姐",
  },
  {
    quote: "把每一起塌房拆成『铸房—裂缝—崩塌』的过程，读完整个人都清醒了。原来滤镜真的是工业流水线。",
    name: "阿凯",
    role: "业余影评人",
  },
  {
    quote: "没有指名道姓地去编排任何人，只讲机制和现象，这份克制让我愿意留下来继续读。",
    name: "雪梨",
    role: "自媒体撰稿人",
  },
];

export const principles = [
  {
    icon: "ri-scales-3-line",
    title: "只看实锤",
    desc: "不搬运未经证实的爆料，事件描述严格基于多方可查证信息。",
  },
  {
    icon: "ri-eye-line",
    title: "不神化任何公众人物",
    desc: "反对把艺人捧成神，也反对因一次翻车就无限贬低一个人。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "讲机制，不搞人身攻击",
    desc: "从行业、心理、媒介三个角度拆解现象，不对个人进行审判。",
  },
  {
    icon: "ri-heart-2-line",
    title: "理性吃瓜",
    desc: "鼓励读者关注作品与真实，减少因完美主义带来的幻灭伤害。",
  },
];